import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import Slide from "@mui/material/Slide";

const style = {
  position: "absolute",
  top: "20%",
  left: "40%",
  width: "21rem",
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const ConfirmationWithInput = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  // Load Dynamic Image
  const loadImage = () => {
    switch (props.image) {
      case "assign":
        //return require('../../assets/assign_color.png');
      case "delete":
       // return require('../../assets/delete.jpeg');
      case "error":
       // return require('../../assets/error.jpeg');
      case "thumb":
       // return require('../../assets/thumbs_up.png');
      case "complete":
        //return require('../../assets/main/hands_up.png');
    }
  };

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => props.toggleModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide
          direction="down"
          in={props.visible}
          container={containerRef.current}
        >
          <Box sx={{ ...style, backgroundColor: "primary.main", border: 0 }}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                px: 5,
              }}
            >
              <Grid item sx={{ justifyContent: "center" }}>
                <img src={loadImage()} width="100em"></img>
              </Grid>
              <Grid item sx={{ my: 2 }}>
                {props.primaryText && (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "center",
                    }}
                  >
                    {props.primaryText}
                  </Typography>
                )}
                {props.secondaryText && (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1rem",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {props.secondaryText}
                  </Typography>
                )}
              </Grid>
              <Grid item sx={{ my: 3 }}>
                <TextField
                  multiline={props.textArea ? true : false}
                  rows={props.textArea ? 4 : 1}
                  id="filled-basic"
                  fullWidth
                  size="small"
                  placeholder="Enter Text Here"
                  value={props.confirmInputText}
                  sx={{ backgroundColor: "#F5F5F5", borderRadius: props.textArea ? 0 : 50 }}
                  InputProps={{
                    inputProps: { style: { fontSize: "1rem" } },
                    style: { borderRadius: props.textArea ? 0 : 50 },
                  }}
                  onInput={(e) => {
                    props.confirmInput(e.target.value);
                  }}
                ></TextField>
              </Grid>

              {!props.alert && (
                <>
                  {!props.confirmText && (
                    <>
                      <Grid item>
                        <Button
                          onClick={props.positiveClick}
                          variant="contained"
                          color="success"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            backgroundColor: "primary.success",
                            color: "#FFF",
                            fontWeight: "bold",
                            mt: 3,
                            px: 2,
                            width: "15em",
                          }}
                        >
                          {props.positiveText ? props.positiveText : "YES"}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={props.negativeClick}
                          variant="contained"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            border: 1,
                            borderColor: "#FFFFFF",
                            color: "#FFF",
                            fontWeight: "bold",
                            mt: 2,
                            px: 2,
                            width: "15em",
                          }}
                        >
                          {props.negativeText ? props.negativeText : "NO"}
                        </Button>
                      </Grid>
                    </>
                  )}
                  {props.confirmText && (
                    <Button
                      onClick={props.confirm}
                      variant="contained"
                      color="success"
                      fullWidth
                      sx={{
                        borderRadius: 10,
                        backgroundColor: "primary.success",
                        color: "#FFF",
                        fontWeight: "bold",
                        mt: 3,
                        px: 9,
                      }}
                    >
                      {props.confirmText}
                    </Button>
                  )}
                </>
              )}
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default ConfirmationWithInput;
